<template>
	<b-dropdown class="account-invite-row-actions">
		<button class="button is-text" slot="trigger">
			<b-icon :icon="icon" size="is-small"></b-icon>
		</button>
		<b-dropdown-item v-if="showExtend" has-link>
			<a @click.prevent="extendInvite">Extend Invitation</a>
		</b-dropdown-item>
		<b-dropdown-item v-if="showPerma" has-link>
			<a @click.prevent="makeInvitePermanent">Make Invitation Permanent</a>
		</b-dropdown-item>
		<b-dropdown-item has-link>
			<a @click.prevent="showLink">Show Invitation Link</a>
		</b-dropdown-item>
		<b-dropdown-item has-link>
			<a @click.prevent="revokeInvite" class="has-text-danger">Revoke Invitation</a>
		</b-dropdown-item>
	</b-dropdown>
</template>

<script>
import { ModalProgrammatic } from 'buefy'
import InviteLink from './Promps/InviteLink.vue'

export default {
  data () {
    return {
      isModalActive: false
    }
  },
  props: {
    invite: {
      type: Object
    },
    icon: {
      type: String,
      default: 'ellipsis-v'
    },
    showExtend: {
      type: Boolean,
      default: true
    },
    showPerma: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    confirmAction (messageText) {
      this.$awn.success(messageText)
      this.$emit('invite-updated', this.invite)
    },
    showError (errorMessage) {
      this.$awn.alert(errorMessage.response.data.message)
    },
    extendInvite () {
      this.$store.dispatch('extendInvite', this.invite.id)
        .then(response => {
          this.confirmAction(response.message)
        })
        .catch(error => {
          this.showError(error)
        })
    },
    revokeInvite () {
      this.$buefy.dialog.confirm({
        title: 'Confirm Invitation Revocation',
        message: 'Are you sure you want to revoke this invitation? This cannot be undone.',
        confirmText: 'Revoke Invitation',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch('revokeInvite', this.invite.id)
            .then(response => {
              this.confirmAction(response.message)
            })
            .catch(error => {
              this.showError(error)
            })
        }
      })
    },
    makeInvitePermanent () {
      this.$store.dispatch('makeInvitePermanent', this.invite.id)
        .then(response => {
          this.confirmAction(response.message)
        })
        .catch(error => {
          this.showError(error)
        })
    },
    showLink () {
      ModalProgrammatic.open({
        parent: this,
        component: InviteLink,
        hasCardModal: true,
        props: {
          inviteId: this.invite.id,
          inviteName: this.invite.invited_user.full_name,
          inviteEmail: this.invite.invited_user.email,
          inviteLink: this.invite.login_link
        }
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/AccountInviteRowActions.vue